<template>
  <a-layout style="margin-top: 2px">
    <a-row :gutter="[4,4]">
      <a-col :span="4">
        <a-card :hoverable="true">
          <icon-font type="icon-caigoudanju" style="font-size: 50px;display:inline-block" />
          <a-statistic
            title="采购单总数"
            :value="orderCountStatistics.poCount"
            :value-style="{ color: 'black',fontWeight: 'bold' }"
            style="display:inline-block;margin-left:30px">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card :hoverable="true">
          <icon-font type="icon-baobiaodanju-xiaoshoudanju" style="font-size: 50px;display:inline-block" />
          <a-statistic
            title="销售单总数"
            :value="orderCountStatistics.soCount"
            :value-style="{ color: 'black',fontWeight: 'bold' }"
            style="display:inline-block;margin-left:30px">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card :hoverable="true">
          <icon-font type="icon-dianpudanjuchulipre" style="font-size: 50px;display:inline-block" />
          <a-statistic
            title="入库件数"
            :value="orderCountStatistics.recepitQty"
            :value-style="{ color: 'black',fontWeight: 'bold' }"
            style="display:inline-block;margin-left:30px">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card :hoverable="true">
          <icon-font type="icon-tiaobochukudan" style="font-size: 50px;display:inline-block" />
          <a-statistic
            title="库存总量"
            :value="orderCountStatistics.invTotalQty"
            :value-style="{ color: 'black',fontWeight: 'bold' }"
            style="display:inline-block;margin-left:30px">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card :hoverable="true">
          <icon-font type="icon-pandian" style="font-size: 50px;display:inline-block" />
          <a-statistic
            title="SKU总数"
            :value="orderCountStatistics.skuCount"
            :value-style="{ color: 'black',fontWeight: 'bold' }"
            style="display:inline-block;margin-left:30px">
          </a-statistic>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card :hoverable="true">
          <icon-font type="icon-jianhuoyichang" style="font-size: 50px;display:inline-block" />
          <a-statistic
            title="出库发货量"
            :value="orderCountStatistics.shipmentQty"
            :value-style="{ color: 'black',fontWeight: 'bold' }"
            style="display:inline-block;margin-left:30px">
          </a-statistic>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="[4,4]" style="margin-top: 2px">
      <a-col :span="14">
        <a-card :hoverable="true">
          <div ref="operationStatistics" style="height: 680px;width: 100%"></div>
        </a-card>
      </a-col>
      <a-col :span="10">
        <div style="width: 100%;height: 670px;">
          <a-card :hoverable="true">
            <a-spin :spinning="inventoryStatisticsLoading">
              <div ref="inventoryStatistics" style="width: 100%;height: 338px"></div>
            </a-spin>
          </a-card>

          <a-card :hoverable="true" style="margin-top: 2px;height: 340px">
            <a-spin :spinning="workStepStatisticsLoading">
              <h2 style="font-weight: bold">作业进度</h2>
              <div style="display: flex">
                <h3 style="font-weight: bold;">收货</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="30" ></a-progress>
                </div>
              </div>
              <div style="display: flex">
                <h3 style="font-weight: bold;">验收</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="50" status="active" />
                </div>
              </div>
              <div style="display: flex">
                <h3 style="font-weight: bold;">上架</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="70" status="exception" />
                </div>
              </div>

              <div style="display: flex">
                <h3 style="font-weight: bold;">拣货</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="100" />
                </div>
              </div>

              <div style="display: flex">
                <h3 style="font-weight: bold;">分播</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="50" :show-info="false" />
                </div>
              </div>

              <div style="display: flex">
                <h3 style="font-weight: bold;">打包</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="30" ></a-progress>
                </div>
              </div>

              <div style="display: flex">
                <h3 style="font-weight: bold;">集货</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="30" ></a-progress>
                </div>
              </div>

              <div style="display: flex">
                <h3 style="font-weight: bold;">装车</h3>
                <div style="width:90%;margin-left: 10px">
                  <a-progress :percent="65" ></a-progress>
                </div>
              </div>

            </a-spin>
          </a-card>

        </div>
      </a-col>
    </a-row>
  </a-layout>
</template>

<script>
import { findAll, findEnum, post } from '@/api/Api'
import { Icon } from 'ant-design-vue'
import * as echarts from 'echarts'
import Api from '@/api'
import Vue from 'vue'
import { OPERATOR, SIDEBAR_TYPE } from '@/store/mutation-types'
import { mapState } from 'vuex'

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4452247_hsblaq8s3kp.js'
})

export default {
  name: 'LedgerQuery',
  components: {
    IconFont
  },
  data() {
    return {
      orderCountStatisticsLoading: false,
      operationStatisticsLoading: false,
      inventoryStatisticsLoading: false,
      workStepStatisticsLoading: false,
      orderCountStatistics: {
        asnCount: 0,
        poCount: 0,
        soCount: 0,
        shipCount: 0,
        waveCount: 0,
        loadCount: 0,
        recepitQty:0,
        invTotalQty:0,
        skuCount:0,
        shipmentQty:0,
      },
      operationStatistics: null,
      operationStatisticsData:{
        
      },
      inventoryStatistics: null,
      workStepStatistics: null,
      operationStatisticsOption: {
        title: {
          text: '操作统计'
        },
        tooltip: {},
        legend: {
          data: ['入库', '出库', '补货', '移库', '盘点']
        },
        xAxis: {
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        },
        yAxis: {},
        series: [
          {
            name: '入库',
            type: 'line',
            data: [1, 3, 5, 7, 9, 1, 7],
            smooth: true
          },
          {
            name: '出库',
            type: 'line',
            data: [5, 2, 6, 7, 0, 8, 19],
            smooth: true
          },
          {
            name: '补货',
            type: 'line',
            data: [5, 11, 36, 10, 10, 10, 18],
            smooth: true
          },
          {
            name: '移库',
            type: 'line',
            data: [5, 13, 33, 11, 1, 55, 120],
            smooth: true
          },
          {
            name: '盘点',
            type: 'line',
            data: [5, 20, 15, 77, 6, 3, 0],
            smooth: true
          }
        ]
      },
      inventoryStatisticsOption: {
        title: {
          text: '库存分布',
          left: 'left'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 10,
          bottom: 10,
          data: []
        },
        series: [
          {
            name: '库房',
            type: 'pie',
            radius: '80%',
            center: ['40%', '50%'],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    sidebarType() {
      return this.$store.state.app.sidebar;
    }
  },
  mounted() {
    this.initOrderCountStatistics()
    this.operationStatistics = echarts.init(this.$refs.operationStatistics)
    this.inventoryStatistics = echarts.init(this.$refs.inventoryStatistics)
    this.initOperationStatistics()
    this.initInventoryStatistics()
    this.$nextTick(() => {
      this.$watch('sidebarType', function (newVal, oldVal) {
        this.operationStatistics.resize()
        this.inventoryStatistics.resize()
      });
    });
  },
  methods: {
    initOrderCountStatistics() {
      this.orderCountStatisticsLoading = true
      const args = {
        'query.no': 'orderCountStatistics',
        'sql': null
      }
      post(Api.adminQuery, {}, args).then(res => {
        if (res.success) {
          Object.assign(this.orderCountStatistics, res.result[0])
        }
      }).finally(() => {
        this.orderCountStatisticsLoading = false
      })
    },
    initOperationStatistics() {
      this.operationStatistics.setOption(this.operationStatisticsOption)
    },
    initInventoryStatistics() {
      this.inventoryStatisticsLoading = true
      const args = {
        'query.no': 'inventoryStatistics',
        'sql': null
      }
      post(Api.adminQuery, {}, args).then(res => {
        if (res.success) {
          let legendData = []
          let seriesData = []
          res.result.forEach(item => {
            legendData.push(item.name)
            seriesData.push({
              name: item.name,
              value: item.count
            })
          })
          this.inventoryStatisticsOption.legend.data = legendData
          this.inventoryStatisticsOption.series[0].data = seriesData
          this.inventoryStatistics.setOption(this.inventoryStatisticsOption)
        }
      }).finally(() => {
        this.inventoryStatisticsLoading = false
      })
    },
    initWorkStepStatistics() {

    }
  }
}
</script>

<style scoped>
.query {
  width: 180px;
}
</style>